import { Spin } from 'antd';

export type LoadingStateProps = {
  message?: string;
};

/** Standard busy state. `role="status"` so screen readers announce it. */
export function LoadingState({ message = 'Loading…' }: LoadingStateProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex flex-col items-center justify-center gap-3 px-4 py-8 text-center"
    >
      <Spin />
      <span className="text-sm text-ink-muted">{message}</span>
    </div>
  );
}
